module.exports = __webpack_public_path__ + "img/three.3cb1dae1.png";